import { PercentageCompleteChangedAlertResponse } from "./PercentageCompleteChangedAlertResponse";

import { PercentageCompleteChangedAlert } from "./PercentageCompleteChangedAlert";

export class PercentageCompleteChangedAlertMapper {
  mapToPercentageCompleteChangedAlert(
    response: PercentageCompleteChangedAlertResponse
  ): PercentageCompleteChangedAlert {
    return {
      id: response.id,
      milestoneTaskId: response.milestoneTaskId,
      from: response.from,
      to: response.to,
      dateCreated: response.dateCreated,
      dateModified: response.dateModified,
    };
  }
}
